import { render, staticRenderFns } from "./ProfileRawOwnersCard.vue?vue&type=template&id=45248fa1&"
import script from "./ProfileRawOwnersCard.vue?vue&type=script&lang=js&"
export * from "./ProfileRawOwnersCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRawOwnersCard.vue?vue&type=style&index=0&id=45248fa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports